module.exports = __webpack_public_path__ + "teqbahn-assets/media/pc1.2545b845.png";